<template>
    
    <div class="card rounded shadow-sm p-3" @click.prevent="$emit('clicked')">
        <div class="d-flex justify-content-between">
            <legend class="text-truncate w-100" >
                <strong class="">(N° {{stone.bloc_number}})</strong>
                {{stone.name_material}} 
            </legend>
            <div>
                <span class="badge badge-pill badge-light text-muted">ID: {{stone.id}}</span>
            </div>
        </div>
        <section class="d-fex justify-content-center thumb">
            <BoxImage :image="stone.images.length > 0? stone.images[0].url : null" :size="25"/>
        </section>
        <section class="p-3 mt-2 bg-light rounded d-flex flex-column">
            <span>{{is_pt_br ? 'Tipo' : 'Type'}}: 
            <strong>{{stone.type}}</strong>
            </span>
            <div class="row">
                <span class="col-6">{{is_pt_br ?  'Largura': 'Width' }}: {{stone.width | formatFloatGlobal}}m</span>
                <span class="col-6">{{is_pt_br ?  'Altura': 'Height' }}: {{stone.height | formatFloatGlobal}}m</span>
            </div>
               <div class="row">
                <span class="col-6">{{is_pt_br ?  'Comprimento' : 'Length' }}: {{stone.diameter | formatFloatGlobal}}m</span>
                <span class="col-6">{{is_pt_br ?  'Peso' : 'Weight'}}: {{stone.weight |formatFloatGlobal}}Ton</span>
            </div>
        </section>
        <footer class="d-flex flex-row-reverse p-2">
            <small>{{is_pt_br ?  'Criado em ' : 'Created at '}} {{stone.created_at | formatDateGlobal}}</small>
        </footer>
    </div>
</template>

<script>
import BoxImage from '../utils/BoxImage.vue'

export default {
    name: "CardStone",
    props: {stone: Object},
    components: { BoxImage},
    computed: {
        is_pt_br(){
            return this.$store.getters.is_pt_br
        }
    }
}
</script>

<style lang="scss" scoped>
.card{
    cursor: pointer;
}
.thumb{
  
}
</style>